<template>
  <!--门户界面-->
  <div :style="{'background-image':'url('+bgImg+')'}" class="container-layout">
    <div class="container-top" style="background:rgba(255, 255, 255, 0.3)">
      <el-row type="flex" justify="start">
        <el-col :span="2" />
        <el-col :span="5">
          <el-row type="flex" justify="start" align="middle">
            <el-col :span="10">
              <img v-if="logoTheme == 'cts'" :src="logoImg" alt="" class="logo-img" style="cursor: pointer;" @click="routeTo('/home/homepage')">
              <img v-if="logoTheme == 'dv'" :src="logoDvImg" alt="" class="logo-img" style="cursor: pointer;" @click="routeTo('/home/homepage')">
            </el-col>
<!--             <el-col :span="19" :offset="1">
              <span class="col-span">
                <i>
                  <img :src="locationIcon" alt="">
                </i>
                <label>{{ locationName }}</label>
              </span>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="16">
          <ul class="ul-tab">
<!--            <li @click="routeTo('/home/homepage')">-->
<!--              <span class="tab-span">-->
<!--                <i>-->
<!--                  <img :src="homeIcon" alt="">-->
<!--                </i>-->
<!--                <router-link to="">{{ $t('login.home') }}</router-link>-->
<!--              </span>-->
<!--            </li>-->
<!--            <li @click="routeTo('/home/serviceGuide')">-->
<!--              <span class="tab-span">-->
<!--                <router-link to="">{{ $t('home.serviceInformation') }}</router-link>-->
<!--              </span>-->
<!--            </li>-->
<!--            <li @click="routeTo()">-->
<!--              <span class="tab-span">-->
<!--                <router-link to="">{{ $t('home.complaintsAndSuggestions') }}</router-link>-->
<!--              </span>-->
<!--            </li>-->
          </ul>
        </el-col>
        <el-col :span="1" />
      </el-row>
    </div>
    <div class="login-container-middle">
       <div class="advertise">
         <img :src="advertise"/>
      </div>
     <div class="login-context" :style="{'background-image':'url('+loginBgImg+')'}">
       <div class="loginpage" :class="{'isShow':isdisplay}">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" autocomplete="on" class="loginForm">
  <!--         <el-row v-if="logoTheme == 'cts'">
              <el-col :span="10">
                <div class="login-title" :style="{'background-image':'url('+loginBgLogo+')'}"></div>
              </el-col>
              <el-col :span="14">
                <div class="login-title" style="padding-top: 7px"  ><span>{{ $t('home.title') }}</span></div>
              </el-col>
          </el-row>
          <el-row v-if="logoTheme == 'dv'">
            <el-col>
              <div v-if="logoTheme == 'dv'" class="login-title" :style="{'background-image':'url('+loginAgLogo+')'}"></div>
            </el-col>
          </el-row> -->
           <el-row v-if="logoTheme == 'cts'">
            <el-col>
              <div v-if="logoTheme == 'cts'" :style="{'background-image':'url('+loginBgLogo+')'}" style="height: 48px;background-repeat: no-repeat;background-size: 100%;margin:100px 0px 80px 0;"></div>
            </el-col>
          </el-row>
          <el-row v-if="logoTheme == 'dv'">
            <el-col>
              <div v-if="logoTheme == 'dv'" :style="{'background-image':'url('+loginAgLogo+')'}" style="height: 48px;background-repeat: no-repeat;background-size: 100%;margin:100px 0px 80px -15px;"></div>
            </el-col>
          </el-row>
          <el-row class="login-row">
            <el-col :span="7" class="login-input-title-vessel">
              <span class="login-input-title">{{$t('login.username')}}</span>
            </el-col>
            <el-col :span="17">
              <el-form-item class="login-register-input" prop="username">
                <el-input
                  ref="username"
                  v-model="loginForm.username"
                  class="login-input"
                  :placeholder="$t('login.username')"
                  name="username"
                  type="text"
                  @change="userChange"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="2">
              <i v-if="trueIconVisible">
                <img class="login-icon" :src="trueIcon" alt="">
              </i>
            </el-col> -->
          </el-row>
          <el-row class="login-row">
             <el-col :span="7" class="login-input-title-vessel">
               <span class="login-input-title">{{$t('login.password')}}</span>
            </el-col>
            <el-col :span="17">
              <el-form-item  class="login-register-input" prop="password">
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.password"
                  class="login-input"
                  :type="passwordType"
                  :placeholder="$t('login.password')"
                  name="password"
                  tabindex="0"
                  autocomplete="on"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                  @change="loginchange"
                  @input="pwdChange"
                  @keyup.enter.native="handleLogin"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="2">
              <i v-if="iconVisible">
                <img class="login-icon" :src="trueIcon" alt="">
              </i>
            </el-col> -->
          </el-row>
          <el-row type="flex" justify="end" style="margin-top:20px;">
             <el-col :span="18" style="text-align:left;color:#ffff;font-size:13px;">
              <router-link to=""><span style="border-bottom:1px solid #ffff;padding: 0px 3px;">{{ $t('login.forgetpassword') }}</span></router-link>
            </el-col>
         </el-row>
          <el-row type="flex" justify="center" style="margin-top: 40px; text-align:center">
            <el-col>
              <el-button class="login-btn" :class="{ 'login-btnload':isbtnload ,'login-btn-disabled':isdisabled}" :loading="loading" :disabled="disabled" @click.native.prevent="handleLogin" >{{ $t('button.signIn') }}</el-button>
            </el-col>
          </el-row>
          <!--   <el-col :span="18" style="text-align:left;color:#FFFFFF;font-size:13px;">
              <router-link :to="{name:'register'}"><span style="border-bottom:1px solid #98A4DA;padding: 0px 3px;">{{ $t('login.register') }}</span></router-link>
            </el-col> -->
          <el-row v-if="logoTheme == 'dv'" style="text-align:center;color:#FFFFFF;font-size:13px;margin-top:10px">
                <span @click="toregister" style="border-bottom:1px solid #98A4DA;padding: 0px 3px;cursor: pointer;">{{ $t('login.register') }}</span>
          </el-row>
       </el-form>
      </div>
        <div class="register-page">
           <div class="registerpage" :class="{'isShow':!isdisplay}">
            <Register @register-display="registerdisplay"></Register>
          </div>
          <el-row class="login-container-bottom">
          <el-row type="flex" justify="center">
          <el-col :span="24" style="text-align:center">
            <label v-if="logoTheme == 'cts'" class="bottom-label-font">CopyRight ©{{ $t('home.ctsCr') }}</label>
            <label v-if="logoTheme == 'dv'" class="bottom-label-font">CopyRight ©{{ $t('home.dvCr') }}</label>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24" style="text-align:center">
            <label class="bottom-label-font">{{ $t('home.glCr') }}</label>
          </el-col>
        </el-row>
          </el-row>
         </div>
     </div>
</div>
<!--     <div class="container-bottom">
      <el-row type="flex" justify="center">
        <el-col :span="8">
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align:center">
              <label v-if="logoTheme == 'cts'" class="bottom-label-font">CopyRight ©{{ $t('home.ctsCr') }}</label>
              <label v-if="logoTheme == 'dv'" class="bottom-label-font">CopyRight ©{{ $t('home.dvCr') }}</label>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align:center">
              <label class="bottom-label-font">{{ $t('home.glCr') }}</label>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div> -->
    <el-dialog :visible.sync="dialogFormVisible" @close="clearvalue('ruleForm')" >
      <div class="changePasswordTitle">修改密码</div>
      <div>当前用户：{{ruleForm.userName}} </div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="oldPwd" >
          <span class="asterisk">*</span><span>旧密码：</span>
          <el-input type="password" v-model="ruleForm.oldPwd" autocomplete="off" class="passwordstyle"></el-input>
        </el-form-item>
        <el-form-item prop="newPwd" >
          <span class="asterisk">*</span> <span>新密码：</span>
          <el-input type="password" v-model="ruleForm.newPwd" autocomplete="off" class="passwordstyle"></el-input>
        </el-form-item>
        <el-form-item prop="confiPwd" >
          <span class="asterisk">*</span><span>确认密码：</span>
          <el-input type="password" v-model="ruleForm.confiPwd" autocomplete="off" class="passwordstyle"></el-input>
        </el-form-item>
        <div class="prompt">提示：密码必须包含大写字母、小写字母、数字或特殊符号,长度必须在8到30之间 </div>
        <el-form-item class="btns">
          <el-button type="primary" @click="queren(ruleForm)">确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <GoHmTipPage v-if="showGoHmTipPage" @close="showGoHmTipPage = false"/> 
  </div>
</template>

<script>
  import { getLocation } from '@/api/messageApi'
  import { validUsername } from '@/utils/validate'
  import { modifyPwdSysUser } from "@/api/system";
  import Register from "@/components/Register/Register.vue"
  import { getUserType } from "@/api/overseas";
  import GoHmTipPage from './components/GoHmTipPage.vue'
  export default {
    name: 'Login',
     components: {
     Register,
     GoHmTipPage
    },
    async created() {

    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('旧密码不能为空'));
        } else {
          if (this.ruleForm.confiPwd !== '') {
            this.$refs.ruleForm.validateField('confiPwd');
          }
          callback();
        }
      };
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.confiPwd !== '') {
            this.$refs.ruleForm.validateField('confiPwd');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.newPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      const validateUsername = (rule, value, callback) => {
        if (!validUsername(value)) {
          callback(new Error('Please enter the correct user name'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('The password can not be less than 6 digits'))
        } else {
          callback()
        }
      }
      return {
       bgImg: require('../../assets/images/login_imgs/login-bgimg.png'),
        logoImg: require('../../assets/images/login_imgs/cts-logo.png'),
        logoDvImg: require('../../assets/images/login_imgs/logo-dv.png'),
        locationIcon: require('../../assets/images/home_imgs/location-icon.png'),
        homeIcon: require('../../assets/images/login_imgs/home-icon.png'),
        loginBgLogo: require('../../assets/images/login_imgs/loginBgLogo.png'),
        loginBgImg: require('../../assets/images/login_imgs/login-bg.png'),
        userIcon: require('../../assets/images/login_imgs/user-icon.png'),
        pwdIcon: require('../../assets/images/login_imgs/pwd-icon.png'),
        trueIcon: require('../../assets/images/login_imgs/true-icon.png'),
        loginAgLogo: require('../../assets/images/login_imgs/login-ag-logo.png'),
        advertise: require("../../assets/images/login_imgs/advertise.png"),
        locationName: window.returnCitySN?.cname,
        trueIconVisible: false,
        iconVisible: false,
        isActive: true,
        loginForm: {
          username: "",
          password: "",
          appCode: "CTS_WEB",
          isExternal: 0,
          isActive: 1
        },
        loginRules: {

        },
        passwordType: 'password',
        capsTooltip: false,
        loading: false,
        showDialog: false,
        redirect: undefined,
        otherQuery: {},
        logoTheme: 'cts',
        dialogFormVisible: false,
        ruleForm: {
          appCode: 'CTS_WEB',
          oldPwd: '',
          newPwd: '',
          confiPwd: '',
          userName: ''
        },
        rules: {
          oldPwd: [
            { validator: validatePass , trigger: 'blur' }
          ],
          newPwd: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          confiPwd: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
       disabled: false,
        isbtnload: false,
        isdisabled: false,
        isdisplay: false,
        showGoHmTipPage: true,//默认打开升级的提示
      }
    },
    computed: {

    },
    watch: {
      $route: {
        handler: function(route) {
          const query = route.query
          if (query) {
            this.redirect = query.redirect
            this.otherQuery = this.getOtherQuery(query)
          }
        },
        immediate: true
      }
    },
    mounted() {
       if(!this.loginForm.username || !this.loginForm.password){
      // if(this.loginForm.username === ''||this.loginForm.username === undefined||this.loginForm.username === null && this.loginForm.password === ''||this.loginForm.password === undefined||this.loginForm.password === null){
        this.disabled =true
        this.isdisabled=true
      }else{
        this.disabled =false
         this.isdisabled=false
      }
      if (this.loginForm.username === '') {
        this.$refs.username.focus()
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus()
      }
      if (this.loginForm.username !== '') {
        this.trueIconVisible = true;
      }
      if (this.loginForm.password !== '') {
        this.iconVisible = true;
      }
      if(localStorage.logoTheme){
        this.logoTheme = localStorage.logoTheme;
      }
    },
    methods: {
      checkCapslock(e) {
        const { key } = e
        this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
      },
      showPwd() {
        if (this.passwordType === 'password') {
          this.passwordType = ''
        } else {
          this.passwordType = 'password'
        }
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      },
      handleLogin() {
        let self = this;
        this.isbtnload=true
        self.loading = true
        self.$store.dispatch('user/login', self.loginForm)
          .then(res => {
            if(res && res.success === true){
/*               self.$router.push({ path: '/dashboard' , query: self.otherQuery })
              self.loading = false  */
           var userTypeParm = {
              sysUserId: res.data.userId,
            };
            getUserType(userTypeParm).then((res) => {
              if (res.records === "2") {
                self.$store.dispatch("tagsView/delAllViewsKeepHp").then();
                self.$router.push({
                  path: "/dashboard",
                  query: self.otherQuery,
                });
                self.loading = false;
              }
              if (res.records === "13") {
                self.$store.dispatch("tagsView/delAllViewsKeepHp").then();
                self.$router.push({
                  path: "/overseas-agency/overseasWelcome",
                  query: self.otherQuery,
                });
                self.loading = false;
                  this.$i18n.locale = 'en'
                  this.$store.dispatch('app/setLanguage', 'en')
              }
            });
            }else{
                self.loading = false
              this.isbtnload=false
              self.loginForm.password = ""
             this.isdisabled=true
              if(res.errorCode == "500001"){
                self.dialogFormVisible = true;
                self.ruleForm.userName = this.loginForm.username;
              }
              return this.$coreMethods.message('error', res.errorMessages[0])
            }

          })
          .catch(res => {
            self.loading = false
        })

        // self.$refs.loginForm.validate(valid => {
        //   if (valid) {
        //     self.loading = true
        //     self.$store.dispatch('user/login', self.loginForm)
        //       .then(() => {
        //         self.$router.push({ path: self.redirect || '/', query: self.otherQuery })
        //         self.loading = false
        //       })
        //       .catch(() => {
        //         self.loading = false
        //       })
        //   } else {
        //     console.log('error submit!!')
        //     return false
        //   }
        // })
      },
      getOtherQuery(query) {
        return Object.keys(query).reduce((acc, cur) => {
          if (cur !== 'redirect') {
            acc[cur] = query[cur]
          }
          return acc
        }, {})
      },
      // 路由跳转
      routeTo(val) {
        this.$router.push(val)
      },
      // 用户名输入框改变事件
      userChange(val) {
    /*     if(this.loginForm.username !== ''){
          this.trueIconVisible = true;
        }else{
          this.trueIconVisible = false;
        } */
         if(this.loginForm.password !== ''&&this.loginForm.username !== ''){
          this.disabled =false
          this.isdisabled=false
        }else{
          this.disabled =true
          this.isdisabled=true
        }
      },
      loginchange(){
        if(this.loginForm.password !== ''&&this.loginForm.username !== ''){
          this.disabled =false
          this.isdisabled=false
        }else{
          this.disabled =true
          this.isdisabled=true
        }
    },
      // 密码输入框改变事件
      pwdChange(val) {
        if(this.loginForm.password !== ''){
          this.iconVisible = true;
        }else{
          this.iconVisible = false;
        }
        this.$forceUpdate()
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogFormVisible=false
      },
      queren(data){
        let self=this
        modifyPwdSysUser(data).then(res => {
          if(res.status===0) {
            self.$coreMethods.message(
              "warning","密码修改成功");
            this.dialogFormVisible=false
          } else  {
            self.$coreMethods.message(
              "warning","旧密码输入不正确，请重新输入");
          }
        }).catch(error => {
          console.log(error)
        })
      },
      clearvalue(formName){
        this.$refs[formName].resetFields();
      },
       registerdisplay(data){
         this.isdisplay=data
          console.log(data)
      },
       toregister(){
        this.isdisplay=!this.isdisplay
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

// ::v-deep .login-input .el-input__inner {
//   background-color: transparent !important;
//   color: #ffffff !important;
//   border: none !important;
// }
.login-title {
  height: 30px;
  background-size: 100% 100%;
}
.login-othertitle{
  height: 30px;
  background-size: 70% 100%;
  background-repeat: no-repeat;
}
// 清除浏览器记住密码后的input的默认样式
::v-deep input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
  -webkit-text-fill-color: rgba(26, 74, 255, 1) !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;

  &.hover-effect {
    cursor: pointer;
    transition: background .3s;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1200px;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  // top: 50px;
  top: 15px;
  // right: 0;
  left: 190px;
  z-index: 1002;
  // width: calc(100% - #{$sideBarWidth});
  width: calc(100% - 450px);
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  // width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}
.fixed-header-container {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1001;
  width: 100%;
}
.fixed-footer-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1001;
  width: 100%;
  height: 50px;
  text-align: center;
  background-color: #353535;
  .footer-text {
    display: flex;
    flex-flow: column;
    font-size: 12px;
    color: #ffffff;
    line-height: 16px;
    margin-top: 10px;
  }
}
.prompt{
  color: red;
  margin-top: 10px;
}
.asterisk{
  color: red;
}
.btns{
  float: right;
  padding-bottom: 20px;
}
.changePasswordTitle{
  text-align: center;
  font-size: 24px;
}
.passwordstylkkkke {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
}
</style>
